import { useCallback } from "react";
import { useAppSelector } from "../../store/hooks";
import { useAddMutation } from "../../store/slices/apiSlice";

export interface ApplicationRequest {
  name: string;
  company: string;
  email: string;
  phone: string;
  comment: string;
  consentAccepted: boolean;
  // captchaToken: string;
}

const getErrorMessage = (error: unknown) => {
  if (!error || typeof error !== "object") {
    return "Не удалось отправить заявку. Попробуйте ещё раз.";
  }

  if ("data" in error) {
    const data = error.data;

    if (typeof data === "string" && data.trim()) {
      return data;
    }

    if (
      data &&
      typeof data === "object" &&
      "message" in data &&
      typeof data.message === "string"
    ) {
      return data.message;
    }
  }

  if ("error" in error && typeof error.error === "string") {
    return error.error;
  }

  return "Не удалось отправить заявку. Попробуйте ещё раз.";
};

export const useApplicationAPI = () => {
  const endpoint = useAppSelector((state) => state.endpoints.contact);
  const [addApplication, mutationState] = useAddMutation();

  const submitApplication = useCallback(
    async (payload: ApplicationRequest) => {
      try {
        return await addApplication({ endpoint, body: payload }).unwrap();
      } catch (error) {
        throw new Error(getErrorMessage(error));
      }
    },
    [addApplication, endpoint]
  );

  return {
    submitApplication,
    ...mutationState,
  };
};
